import { NavLink } from "react-router-dom";
import UserSignIn from "../header/UserSighin";
import DetailsWindow from "../containers/DetailsWindow";
import React from "react";
import CostumerCoupons from "./CostumerCoupons";

const PersonalInformation = ({ parent }) => {
  return (
    <div className="private-area">
      <section id="info"></section>
      {parent === "cart" ? (
        <DetailsWindow title="פרטי לקוח">
          <NavLink className="btn-edit-details" to="/private-area/#info">
            שינוי פרטים &gt;{" "}
          </NavLink>
          <UserSignIn parentName="endShopping" />
        </DetailsWindow>
      ) : (
        <DetailsWindow title="פרטי לקוח">
          <UserSignIn parentName="privateArea" />
        </DetailsWindow>
      )}
      <CostumerCoupons />
    </div>
  );
};

export default PersonalInformation;
